import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Header = styled.header``;

export const Container = styled.div`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const IllustrationContainer = styled.div<{ $hasImage: boolean }>`
  align-self: center;
  position: relative;
  display: block;

  ${({ theme, $hasImage }) =>
    theme.isMobile &&
    $hasImage &&
    css`
      display: none;
    `};
`;

export const ImageContainer = styled.div<{ $hasImage: boolean }>`
  position: relative;
  width: 8rem;
  height: 8rem;

  border-radius: ${({ theme }) => theme.spacing(3)};
  overflow: hidden;

  font-size: 4rem;
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(4)};

  width: 100%;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  justify-content: space-between;
`;

export const ContentHeader = styled.div``;

export const DescriptionContainer = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  textarea::placeholder {
    color: ${({ theme }) => theme.palette.text.secondary};
    opacity: 1;
  }
`;
